import { useEffect, useMemo, useState } from 'react';
import { getTokens } from 'common/services/api-tokens.service';

const useApiTokens = () => {
  const [apiTokens, setApiTokens] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const activeTokens = useMemo(
    () => apiTokens.filter(token => token?.status === 'active'),
    [apiTokens]
  );

  const isActiveTokenExists = !isLoading && activeTokens.length > 0;

  const fetchApiTokens = async () => {
    try {
      setIsLoading(true);
      const response = await getTokens();
      setApiTokens(response?.tokens || []);
    } catch (e) {
      setApiTokens([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApiTokens();
  }, []);

  return {
    isLoading,
    data: apiTokens,
    activeTokens,
    isActiveTokenExists
  };
};

export default useApiTokens;
